<template>
  <hm-content title="">
    <el-radio-group
      v-model="searchCondition.verifyType"
      @change="qiehuan"
      size="small"
    >
      <el-radio-button label="coupon">优惠券使用</el-radio-button>
      <el-radio-button label="order">订单提货</el-radio-button>
      <el-radio-button label="subscribe">预约活动</el-radio-button>
      <el-radio-button label="game">活动奖品发放</el-radio-button>
      <el-radio-button label="offline">线下抽奖</el-radio-button>
      <el-radio-button label="card">储值卡核销</el-radio-button>
      <el-radio-button label="vouchers">兑换券使用</el-radio-button>
      <el-radio-button label="serviceWriteOff">预约服务核销</el-radio-button>
    </el-radio-group>

    <div class="mt20" v-if="searchCondition.verifyType !== 'vouchers'">
      <el-radio-group v-model="state" @change="hxChange" size="small">
        <el-radio-button
          label="hxPhone"
          v-if="
            searchCondition.verifyType !== 'offline' &&
            searchCondition.verifyType !== 'subscribe'
          "
          >手机号核销</el-radio-button
        >
        <el-radio-button label="hxCode">核销码核销</el-radio-button>
        <el-radio-button v-if="searchCondition.verifyType=='order'" label="batchHx">批量导入核销</el-radio-button>
      </el-radio-group>
    </div>





    <div class="mt20" v-if="searchCondition.verifyType !== 'vouchers'">
      <!-- 批量导入核销 -->
      <template v-if="state === 'batchHx'">
        <div class="flex mb20">
          <el-button type="primary" size="small" @click="outputExcel">下载模板</el-button>
          <div class="ml10 pointer open-file">
            <el-button  type="primary" size="small">
              批量导入订单
              <input
              type="file"
              @change="importf"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            /></el-button>
          </div>
        </div>
        <div style="width: 40%">
          <el-table :data="finalImportTable" 
              stripe
              style="width: 100%"
              id="table"
              size="small"
              border
              @selection-change="getChecked">
          <el-table-column
            prop="receiptSn"
            label="订单号"
          ></el-table-column>
          <el-table-column
            prop="billNo"
            label="核销码"
          ></el-table-column>
        </el-table>
          <div class="hm-pagination mb10">
            <el-pagination
              background
              :total="hxTotal"
              @current-change="paging"
              @size-change="handleSizeChange"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="currentPage"
            ></el-pagination>
          </div>
          <div class="flex hx-remark-wrap item-center mt20">
            <span class="label">核销备注：</span>
            <el-input class="mr10" style="width: 300px" v-model.trim="hxRemark" placeholder="请输入核销备注" size="small" clearable></el-input>
            <el-button @click="handleHx" class="ml20" type="primary" size="small">核销</el-button>
          </div>
        </div>
      </template>
      <!-- 手机号核销and核销码核销 -->
      <template v-else>
        <div
          v-if="state === 'hxCode' && searchCondition.verifyType !== 'offline' && searchCondition.verifyType !== 'serviceWriteOff'"
        >
          <div class="mt20">
            <div v-if="searchCondition.verifyType === 'card'" class="mb10">
              <el-input
                clearable
                style="width:300px"
                v-model.trim="searchCondition.verifyMoney"
                @input="filterGt0OrFixed2('verifyMoney')"
                placeholder="请输入核销金额"
                size="small"
                class="ipt mr10"
              ></el-input>
            </div>

            <el-input
              clearable
              style="width:300px"
              @keyup.enter.native="hxcode"
              v-model.trim="searchCondition.keyword"
              placeholder="请输入相关唯一码或用扫码设备进行核销"
              size="small"
              class="ipt mr10"
            ></el-input>

            <el-button
              type="primary"
              size="small"
              @click="hxcode"
              :disabled="searchCondition.keyword === ''"
              >核销</el-button
            >
            <div class="hmicon">
              <i class="hmicon icon-wenhao"></i><span>如何试用扫码设备核销</span>
            </div>
          </div>
          <div style="marginTop:50px">
            <div class="header-tutorial">
              扫码设备验票
            </div>
            <div class="mt10 tit-tutorial">
              电脑连接二维码扫码设备，点击验票输入框，使用扫码设备扫描用户提供的电子票二维码即可获取数字码进行验票
            </div>
            <div class="mt10 flex flex-start">
              <el-image
                class="mr10 mt10"
                style="width:350px;"
                src="https://imgcdn.hemiao100.com/ThemePictures/bb93e17f56ef19394079d3974bd9caf.png"
              >
              </el-image>
            </div>
            <div class="header-tutorial mt20">
              手机扫码验票
            </div>
            <div class="mt10 tit-tutorial">
              将二维码放置于扫描框内，适当调节扫描距离，系统即跳出票券的使用状态窗口（已通过、已过期、票券无效等)，并伴有声音。网络稳定情况下，识别速度为2s/人。
            </div>
            <div class="mt10 flex flex-start">
              <el-image
                class="mr10 mt10"
                style="width:350px;"
                src="https://imgcdn.hemiao100.com/ThemePictures/3825ee9712e7f17dcd499c88e4bfc82.png"
              >
              </el-image>
            </div>
          </div>
        </div>
        <div v-else>
          <!-- 预约服务核销 -->
          <template v-if="searchCondition.verifyType == 'serviceWriteOff'">

            <div class="mt20 services">
              <el-input
                v-if="state === 'hxPhone'"
                clearable
                style="width:300px"
                v-model.trim="serviceMobilePhoneNumber"
                @keyup.enter.native="search"
                placeholder="请输入会员手机号"
                size="small"
                class="ipt mr10"
              ></el-input>

              <el-input
                v-if="state === 'hxCode'"
                clearable
                style="width:300px"
                v-model.trim="serviceMobilePhoneNumber"
                @keyup.enter.native="search"
                placeholder="请输入核销码"
                size="small"
                class="ipt mr10"
              ></el-input>

              <el-button
                type="primary"
                size="small"
                @click="searchServe"
                :disabled="serviceMobilePhoneNumber === ''"
                >查询</el-button
              >
              <div class="table mt10" v-if="writeOffList && writeOffList.length > 0">
                <div class="list" v-for="(item,index) in writeOffList" :key="index" :class="{active: index == writeActiveIndex}" @click="selectServe(item, index)">
                  <div class="list_title flex">
                    <img src="https://redpackge.oss-cn-hangzhou.aliyuncs.com/static/fuwu/Frame%20(2).svg">
                    <h3>{{ item.shopName }}</h3>
                  </div>
                  <div class="name_mobile flex">
                    <img src="https://redpackge.oss-cn-hangzhou.aliyuncs.com/static/fuwu/Frame%20(3).svg">
                    <p class="username">{{ item.memberName }}</p>
                    <p class="cellPhone">{{ item.memberMobile }}</p>
                  </div>

                  <p class="number">单号：{{ item.serviceSn }}</p>
                  <p class="time">时段:{{ item.subscribeDate }}（{{getDayOfWeek(item.subscribeDate)}}）{{item.startTimeQuantum}}-{{ item.endTimeQuantum}}</p>

                  <ul>
                    <li>
                      <div class="th">{{ item.serviceType }}</div>
                      <div class="tr">类型</div>
                    </li>
                    <li>
                      <div class="th">{{ item.serviceName }}</div>
                      <div class="tr">预约服务</div>
                    </li>
                    <li>
                      <div class="th">{{ item.realname}}</div>
                      <div class="tr">服务技师</div>
                    </li>
                    <li>
                      <div class="th">{{ item.applyNum }}人</div>
                      <div class="tr">预约人数</div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="table mt10" v-else>
               <p style="padding:20px;text-align:center;">暂无数据...</p>
              </div>

              <div class="mt10 flex flex-center">
                <el-button size="small" type="primary" @click="serviceWriteOffFunc">核销</el-button>
              </div>
            </div>

          </template>
          <template v-else>
            <div class="mt20" v-if="searchCondition.verifyType !== 'offline'">
              <el-input
                clearable
                style="width:300px"
                v-model.trim="searchCondition.memberMobile"
                placeholder="请输入会员手机号"
                size="small"
                class="ipt mr10"
              ></el-input>

              <el-button
                type="primary"
                size="small"
                @click="search"
                :disabled="searchCondition.memberMobile === ''"
                >查询</el-button
              >
            </div>
            <div class="mt20" v-else>
              <el-input
                clearable
                v-if="state === 'hxCode'"
                style="width:300px"
                v-model.trim="searchCondition.verifyCode"
                placeholder="请输入相关唯一码或用扫码设备进行核销"
                size="small"
                class="ipt mr10"
                @keyup.enter.native="search"
              ></el-input>

              <el-button
                v-if="state === 'hxCode'"
                type="primary"
                size="small"
                @click="search"
                :disabled="searchCondition.verifyCode === ''"
                >查询</el-button
              >
              <div class="mt10" v-if="state === 'hxCode' && list.length">
                <el-input
                  clearable
                  style="width:300px"
                  @input="filterGt0OrFixed0('remainExchangeNum')"
                  v-model.trim="remainExchangeNum"
                  placeholder="请输入核销次数"
                  size="small"
                  class="ipt mr10"
                ></el-input
                >核销次数 / 最多可核销 {{ drawNum }} 次
              </div>

              <el-input
                clearable
                v-if="state === 'hxPhone'"
                style="width:300px"
                v-model.trim="searchCondition.memberMobile"
                placeholder="请输入手机号"
                size="small"
                class="ipt mr10"
              ></el-input>

              <el-button
                v-if="state === 'hxPhone'"
                type="primary"
                size="small"
                @click="search"
                :disabled="searchCondition.memberMobile === ''"
                >查询</el-button
              >
            </div>
            <div
              class="phone-hxbd mt20 p10"
              v-if="searchCondition.verifyType !== 'card'"
            >
              <div v-if="searchCondition.verifyType === 'coupon'">
                <div>
                  <el-input
                    clearable
                    style="width:300px;margin-left:50px"
                    v-model.trim="searchCondition.couponName"
                    placeholder="请输入优惠券名字关键词"
                    size="small"
                    class="ipt mt20 mr10"
                  ></el-input>
                  <el-button
                    type="primary"
                    size="small"
                    @click="findCoupon"
                    :disabled="searchCondition.memberMobile === ''"
                    >查询</el-button
                  >
                  <el-button type="primary" size="small" @click="freeze"
                    >冻结</el-button
                  >
                </div>   
                <div>
                  <span style="margin-left:50px;">备注:</span>
                  <el-input
                    clearable
                    style="width:300px;margin-left:10px"
                    v-model.trim="verifyRemark"
                    placeholder="请输入备注"
                    size="small"
                    class="ipt mt20 mr10"
                  ></el-input>
                </div>     
              </div>
              <div
                class="ml20 mt20 font-style"
                v-if="searchCondition.verifyType === 'order'"
              >
                待发货订单
              </div>
              <div
                class="ml20 mt20 font-style"
                v-if="searchCondition.state === 'subscribe'"
              >
                活动预约
              </div>
              <div
                class="ml20 mt20 font-style"
                v-if="searchCondition.verifyType === 'game'"
              >
                奖品发放
              </div>
              <el-checkbox-group
                class="mt20"
                v-model="checkCouponsList"
                v-if="searchCondition.verifyType === 'coupon'"
                @change="checkedCoupons"
              >
                <div v-if="list.length > 0">
                  <div class="list-item" v-for="(v, i) in list" :key="i">
                    <el-checkbox :label="v" class="flex-1 flex item-center">
                      <div
                        class="list-box flex flex-wrap"
                        style="width:550px;height:110px"
                        :class="`act${v.type}`"
                      >
                        <div class="list-left">
                          <span class="zhekou" v-if="v.type === '0'"
                            >{{ v.account.toFixed(2) }}元</span
                          >

                          <span class="zhekou" v-if="v.type === '3'"
                            >{{ v.discount }}折</span
                          >
                          <span class="zhekou" v-if="v.type === '2'"
                            >{{ v.account.toFixed(2) }}元运费</span
                          >
                          <span class="tiaojian">满{{ v.levelMin }}元可用</span>
                        </div>
                        <div class="list-right">
                          <div class="right-top">
                            <span class="right-title">
                              {{ v.name }}
                            </span>
                            <div class="right-time">
                              {{ v.startDate }}至{{ v.endDate }}
                            </div>
                            <div class="remaining-time mt10">
                              剩余时间：<span>{{ v.djs }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="flex item-center ml20" v-if="v.useRank !== 1">
                          <el-button size="small" type="text" @click="openCoupon(v)"
                            >打开券码</el-button
                          >
                        </div>
                      </div>
                      <div class="circle1"></div>
                    </el-checkbox>
                  </div>
                </div>
                <div class="flex flex-center" v-if="list.length < 1">
                  暂无数据...
                </div>
              </el-checkbox-group>
              <el-checkbox-group
                class="mt20"
                v-model="checkOrderList"
                v-if="searchCondition.verifyType === 'order'"
                @change="checkedOrder"
              >
                <div>
                  <div class="list-item" v-for="(v, i) in orderList" :key="i">
                    <el-checkbox :label="v.billNo" class="flex item-center">
                      <div class="list-order">
                        <div class="flex flex-between">
                          <div style="fontWeight:400">
                            订单号：{{ v.receiptSn }}
                          </div>
                          <div class="blue">
                            待发货
                          </div>
                        </div>
                        <div
                          class="flex flex-wrap mt10"
                          v-for="(c, index) in v.goodsList"
                          :key="index"
                        >
                          <div class="order-img">
                            <img style="width:100%" :src="c.goodsImg" alt="" />
                          </div>
                          <div class="ml10" style="width:280px">
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="c.spuName"
                              placement="top-start"
                            >
                              <div
                                class="nnn"
                                style="fontSize:14px;fontWeight:bold"
                              >
                                {{ c.spuName }}
                              </div>
                            </el-tooltip>

                            <div class="mt10">￥{{ c.actuallyPrice }}</div>
                            <div style="color:#999999;fontSize:12px;">
                              {{ c.specIdGroupName }}
                            </div>
                          </div>
                          <div class="flex item-center flex-end" style="width:40px">
                            x{{ c.goodsNum }}
                          </div>
                        </div>
                        <div
                          class="flex flex-end"
                          style="fontSize:15px;fontWeight:400;"
                        >
                          共{{ v.totalGoodsNum }}件，合计￥{{ v.actuallyPrice }}
                        </div>
                      </div>
                    </el-checkbox>
                  </div>
                </div>
              </el-checkbox-group>
              <el-checkbox-group
                class="mt20"
                v-model="checkSigninList"
                v-if="searchCondition.verifyType === 'subscribe'"
                @change="checkedSignin"
              >
                <div>
                  <div class="list-item" v-for="(v, i) in list" :key="i">
                    <el-checkbox :label="v.authCode" class="flex item-center">
                      <div class="list-signin">
                        <div class="flex flex-wrap">
                          <div class="signin-img mr10">
                            <img
                              style="width:100%;height:100%"
                              :src="v.mainImgUrl"
                              alt=""
                            />
                          </div>
                          <div class="flex-1" style="width:300px">
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="v.actName"
                              placement="top-start"
                            >
                              <div
                                class="nnn"
                                style="fontSize:14px;fontWeight:bold"
                              >
                                活动名称：<span class="info-content">{{
                                  v.actName
                                }}</span>
                              </div>
                            </el-tooltip>
                            <div class="mt10">活动场次：{{ v.actRound }}</div>
                            <div
                              style="color:#999999;fontSize:14px;lineHeight:14px;"
                            >
                              用户名：{{ v.realName }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-checkbox>
                  </div>
                  <div class="flex flex-center" v-if="list.length < 1">
                    暂无数据...
                  </div>
                </div>
              </el-checkbox-group>
              <el-checkbox-group
                class="mt20"
                v-model="checkPrizeList"
                v-if="searchCondition.verifyType === 'game'"
                @change="checkedPrize"
              >
                <div>
                  <div class="list-item" v-for="(v, i) in list" :key="i">
                    <el-checkbox :label="v.redeemCode" class="flex item-center">
                      <div class="list-prize">
                        <div class="flex flex-wrap">
                          <!-- <div class="prize-img mr10">
                            <img
                              style="width:100%"
                              src="https://imgcdn.hemiao100.com/ThemePictures/timg33.jpg"
                              alt=""
                            />
                          </div> -->
                          <div class="flex-1">
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="v.gameName"
                              placement="top-start"
                            >
                              <div
                                class="nnn"
                                style="width:350px;fontSize:14px;fontWeight:bold"
                              >
                                活动名称：{{ v.gameName }}
                              </div>
                            </el-tooltip>
                            <div class="mt10">
                              活动类型：
                              <span v-if="v.gameType === 'turntable'">大转盘</span>
                              <span v-if="v.gameType === 'red_envelope_rain'">红包雨</span>
                              <span v-if="v.gameType === 'lottery_team'">抽奖团</span>
                            </div>
                            <div>
                              活动时间：{{ v.gameStartTime }}至{{ v.gameEndTime }}
                            </div>
                            <div>获奖时间：{{ v.winningTime }}</div>
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="v.prizeName"
                              placement="top-start"
                            >
                              <div class="primary nnn" style="width:350px;">
                                奖品名称：{{ v.prizeName }}
                              </div>
                            </el-tooltip>
                          </div>
                        </div>
                      </div>
                    </el-checkbox>
                  </div>
                  <div class="flex flex-center" v-if="list.length < 1">
                    暂无数据...
                  </div>
                </div>
              </el-checkbox-group>
              <!-- <div class="flex flex-center" v-if="orderList.length < 1 ||list.length < 1" >
                    暂无数据...
              </div> -->
              <div
                class="tableoffline"
                v-if="searchCondition.verifyType === 'offline'"
              >
                <div v-if="state === 'hxCode'">
                  <el-table
                    stripe
                    v-if="list.length"
                    :data="list"
                    style="width: 100%"
                    id="table"
                    size="small"
                    border
                    @selection-change="getChecked"
                  >
                    <!-- <el-table-column
                      label="单选"
                      width="55"
                      header-align="center"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-radio
                          :label="scope.row.id"
                          v-model="templateRadio"
                          @change.native="checkedOffline(scope.row)"
                          >&nbsp</el-radio
                        >
                      </template>
                    </el-table-column> -->
                    <el-table-column
                      header-align="center"
                      align="center"
                      type="selection"
                      width="50"
                      :selectable="checkboxT"
                    >
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="prizeLevel"
                      label="奖项"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.prizeLevel }}
                      </template>
                    </el-table-column>

                    <el-table-column
                      header-align="center"
                      align="center"
                      label="奖品"
                      prop="prizeName"
                    >
                      <template slot-scope="scope">
                        <div v-if="scope.row.prizeName === '未中奖'">
                          未中奖
                        </div>
                        <div v-else>
                          {{ scope.row.prizeName }}
                          <!-- *{{ scope.row.prizeNum }} -->
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="memberPrizeNum"
                      label="获奖数"
                    >
                      <template slot-scope="scope">
                        <div v-if="scope.row.prizeName !== '未中奖'">
                          <div
                            class="danger"
                            v-if="scope.row.prizeLevelRemainNum === 0"
                          >
                            已兑完
                          </div>
                          <div v-else>
                            <el-input
                              clearable
                              @input="
                                filterListGt0OrFixed0(
                                  scope.$index,
                                  'memberPrizeNum'
                                )
                              "
                              v-model.trim="scope.row.memberPrizeNum"
                              placeholder="请输入获奖数"
                              size="small"
                              class="ipt mr10"
                            ></el-input
                            >/ {{ scope.row.prizeLevelRemainNum }}
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="flex flex-center" v-if="list.length < 1">
                    暂无数据~
                  </div>
                </div>
                <div v-else>
                  <el-table
                    stripe
                    :data="list"
                    style="width: 100%"
                    id="table"
                    size="small"
                    border
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      header-align="center"
                      align="center"
                      width="55"
                      :index="index => index + (currentPage - 1) * pageSize + 1"
                    >
                      <!-- <template slot-scope="scope">
                        {{ scope.$index + (currentPage - 1) * pageSize + 1 }}
                      </template> -->
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="limitAmount"
                      label="奖券对应档位"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.limitAmount }}
                      </template>
                    </el-table-column>

                    <el-table-column
                      header-align="center"
                      align="center"
                      label="奖券兑换时间"
                      prop="exchangeTime"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.exchangeTime }}
                      </template>
                    </el-table-column>

                    <el-table-column
                      header-align="center"
                      align="center"
                      label="奖券兑换订单"
                      prop="orderSns"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.orderSns }}
                      </template>
                    </el-table-column>

                    <el-table-column
                      header-align="center"
                      align="center"
                      label="兑换订单金额"
                      prop="verifyOrderAmount"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.verifyOrderAmount }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      header-align="center"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-button
                          size="small"
                          type="text"
                          @click="hxOffline(scope.row)"
                          >核销抽奖</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>

              <div
                class="hm-pagination mb10"
                v-if="searchCondition.verifyType !== 'offline'"
              >
                <el-pagination
                  background
                  :total="total"
                  @current-change="paging"
                  @size-change="handleSizeChange"
                  layout="total,sizes,  prev, pager, next, jumper"
                  :current-page="currentPage"
                ></el-pagination>
              </div>
            </div>
            <div v-else class="mt10">
              <div v-if="cardList.length">
                <div class="flex item-center">
                  <el-select
                    style="width:300px"
                    class="mr10"
                    v-model="checkedCardInfo.cardRelId"
                    size="small"
                    filterable
                    @change="cardChange"
                  >
                    <el-option
                      :label="v.cardName"
                      :value="v.cardRelId"
                      v-for="(v, i) in cardList"
                      :key="i"
                    ></el-option>
                  </el-select>
                  <div class="mr10">余额：{{ checkedCardInfo.cardBalance }}元</div>
                  <div>
                    <el-input
                      clearable
                      style="width: 200px"
                      v-model.trim="checkedCardInfo.verifyMoney"
                      placeholder="请输入核销金额"
                      @input="filterGt0OrCardFixed2('verifyMoney')"
                      size="small"
                      class="ipt mr10"
                    >
                    </el-input>
                    <el-button
                      type="primary"
                      size="small"
                      @click="getcode"
                      :disabled="!!checkedCardInfo.smsCode"
                      >获取验证码</el-button
                    >
                  </div>
                </div>
                <div class="mt10">
                  <el-input
                    clearable
                    style="width: 200px"
                    v-model.trim="checkedCardInfo.smsCode"
                    placeholder="请输入验证码"
                    size="small"
                    class="ipt mr10"
                  >
                  </el-input>
                  <el-button
                    type="primary"
                    size="small"
                    @click="confirmCard"
                    :disabled="checkedCardInfo.smsCode === ''"
                    >确认核销</el-button
                  >
                </div>
              </div>
            </div>

            <div
              class="mt10 flex flex-center"
              v-if="
                searchCondition.verifyType !== 'offline' &&
                  searchCondition.verifyType !== 'card'
              "
            >
              <el-button size="small" type="primary" @click="confirm"
                >核销{{
                  searchCondition.verifyType === "order" ? "(发货)" : ""
                }}</el-button
              >
            </div>
            <div class="mt10 flex flex-center">
              <el-button
                size="small"
                type="primary"
                @click="confirm"
                :disabled="list.length === 0"
                v-if="state === 'hxCode'"
                >核销{{
                  searchCondition.verifyType === "order" ? "(发货)" : ""
                }}</el-button
              >
            </div>
          </template>
        </div>
      </template>
    </div>

    <!-- 预约服务核销 -->
    <!-- <div v-if="searchCondition.verifyType === 'serviceWriteOff'" class="mt20 services">
      <el-input
        clearable
        style="width:300px"
        v-model.trim="couponCodes"
        @keyup.enter.native="search"
        placeholder="请输入相关唯一码或用扫码设备进行核销"
        size="small"
        class="ipt mr10"
      ></el-input>

      <el-button
        type="primary"
        size="small"
        @click="search"
        :disabled="couponCodes === ''"
        >查询</el-button
      >
      <div class="table mt10">
  
        <div class="list">
          <div class="list_title flex">
            <img src="https://redpackge.oss-cn-hangzhou.aliyuncs.com/static/fuwu/Frame%20(2).svg">
            <h3>爱琴海瑞鼎城店</h3>
          </div>
          <div class="name_mobile flex">
            <img src="https://redpackge.oss-cn-hangzhou.aliyuncs.com/static/fuwu/Frame%20(3).svg">
            <p class="username">郑文锦</p>
            <p class="cellPhone">13387542416</p>
          </div>

          <p class="number">单号：FW17312911665036898</p>
          <p class="time">时段:2024-11-12（周二）08:00-12:00</p>

          <ul>
            <li>
              <div class="th">推拿</div>
              <div class="tr">类型</div>
            </li>
            <li>
              <div class="th">小儿推拿</div>
              <div class="tr">预约服务</div>
            </li>
            <li>
              <div class="th">屈丽珍</div>
              <div class="tr">服务技师</div>
            </li>
            <li>
              <div class="th">2人</div>
              <div class="tr">预约人数</div>
            </li>
          </ul>

        </div>





      </div>
      <div class="mt10 flex flex-center">
        <el-button size="small" type="primary" @click="confirm">核销</el-button>
      </div>
    </div> -->
    <!-- /预约服务核销 -->






    <div v-if="searchCondition.verifyType === 'vouchers'" class="mt20">
      <el-input
        clearable
        style="width:300px"
        v-model.trim="couponCodes"
        @keyup.enter.native="search"
        placeholder="请输入相关唯一码或用扫码设备进行核销"
        size="small"
        class="ipt mr10"
      ></el-input>

      <el-button
        type="primary"
        size="small"
        @click="search"
        :disabled="couponCodes === ''"
        >查询</el-button
      >
      <div class="table mt10">
        <el-table
          stripe
          :data="list"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            width="99"
            label="选择"
          >
            <template slot-scope="scope">
              <el-radio
                :label="scope.$index + (currentPage - 1) * pageSize + 1"
                v-model="radio"
                @change.native="getCurrentRow(scope.row)"
              ></el-radio>
            </template>
          </el-table-column>
          <!-- <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
            width="55"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          >
          </el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsInfo"
            label="商品名称"
          >
            <template slot-scope="scope">
              {{ scope.row.goodsInfo }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="skuName"
            label="商品规格"
          >
            <template slot-scope="scope">
              {{ scope.row.skuName }}
            </template>
          </el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            prop="barCode"
            label="条码"
          >
            <template slot-scope="scope">
              {{ scope.row.barCode }}
            </template>
          </el-table-column> -->
        </el-table>
        <div class="hm-pagination mb10">
          <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
      <div class="mt10 flex flex-center">
        <el-button size="small" type="primary" @click="confirm">核销</el-button>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="500px">
      <div class="flex flex-center">
        优惠券码: <span class="primary"> {{ couponCode }}</span>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="核销抽奖"
      width="1300px"
      :visible.sync="dialogVisibleHx"
    >
      <el-table
        stripe
        :data="hxList"
        style="width: 100%"
        id="table"
        size="small"
        border
      >
        <el-table-column
          label="单选"
          width="55"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-radio
              :label="scope.row.id"
              v-model="templateRadio"
              @change.native="checkedOffline(scope.row)"
            >
              &nbsp;</el-radio
            >
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="prizeLevel"
          label="奖项"
        >
          <template slot-scope="scope">
            {{ scope.row.prizeLevel }}
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          label="奖品"
          prop="prizeName"
        >
          <template slot-scope="scope">
            {{ scope.row.prizeName }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="prizeNum"
          label="数量"
        >
          <template slot-scope="scope">
            {{ scope.row.prizeNum }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="confirm(scope.row)"
              >确认核销</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button size="small" type="primary" @click="confirm">核销</el-button>
      </span>
    </el-dialog>






    <!-- 预约活动核销选择门店弹框 -->
    <el-dialog
      title="选择核销门店"
      :visible.sync="shopDialogVisible"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="shop-select-wrap">
        <el-form label-width="100px">
          <el-form-item label="核销码名称" v-if="hexiaoInfo">
            <span>{{ hexiaoInfo.verifyName }}</span>
          </el-form-item>
          <el-form-item label="会员姓名" v-if="hexiaoInfo">
            <span>{{ hexiaoInfo.memberName }}</span>
          </el-form-item>
          <el-form-item label="会员电话" v-if="hexiaoInfo">
            <span>{{ hexiaoInfo.memberMobile }}</span>
          </el-form-item>
          <el-form-item label="活动场次" v-if="hexiaoInfo">
            <span>{{ hexiaoInfo.actRound }}</span>
          </el-form-item>
           <el-form-item label="活动地点" v-if="hexiaoInfo">
            <span>{{ hexiaoInfo.actSite }}</span>
          </el-form-item>
          <el-form-item label="选择门店">
            <el-select
              v-model="selectedShopName"
              placeholder="请选择门店"
              style="width: 100%"
              filterable
              clearable
            >
              <el-option
                v-for="item in shopList"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="shopDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="confirmSubscribeWriteOff">确认核销</el-button>
      </span>
    </el-dialog>

  </hm-content>
</template>

<script>
import { getLoginUser } from "@/utils/auth";
import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; 
function InitTime(endtime) {
  var dd,
    hh,
    mm,
    ss = null;
  var time = new Date(endtime).getTime() - new Date().getTime();

  if (time <= 0) {
    return "结束";
  } else {
    dd = Math.floor(time / 60 / 60 / 24);
    hh = Math.floor((time / 60 / 60) % 24);
    mm = Math.floor((time / 60) % 60);
    ss = Math.floor(time % 60);
    var str = dd + "天" + hh + "小时" + mm + "分" + ss + "秒";
    return str;
  }
}

export default {
  components: {},
  data() {
    return {
      writeActiveIndex: -1,
      writeOffList:[],
      serviceMobilePhoneNumber:'',
      radio: "",
      verifyCode: "",
      remainExchangeNum: 0,
      title: "",
      couponCode: "",
      dialogVisibleHx: false,
      dialogVisible: false,
      total: 0,
      hxTotal: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {
        verifyCode: "",
        verifyType: "coupon",
        memberMobile: "",
        keyword: "",
        verifyMoney: ""
      },
      state: "hxPhone",
      activeIndex: "11",
      list: [],
      orderList: [],
      lists: [
        {
          gameName:
            "1222222222222222222222222222222222222222222222222222222222222222222222222222222222",
          time: "2019-12-31 18:50:00"
        },
        {
          time: "2019-12-30 18:50:00"
        },
        {
          time: "2019-12-29 18:50:00"
        }
      ],
      checkCouponsList: [],
      checkOrderList: [],
      checkSigninList: [],
      checkPrizeList: [],
      countDownList: "00天00时00分00秒",
      actEndTime: "2019-12-31 18:50:00",
      couponsCodes: [],
      orderCodes: [],
      signinCodes: [],
      prizeCodes: [],
      couponIdList: [],
      obtainPrize: "",
      templateRadio: "",
      hxList: [],
      checkedRow: [],
      drawNum: 0,
      verificationList: {},
      templateSelection: {},
      couponCodes: "",
      copyCouponCodes: "",
      cardList: [],
      checkedCardInfo: {},
      verifyRemark: "",
      importTableList: [],
      billNoList: [],
      storeCode: "",
      hxRemark: "",
      // 预约活动核销相关
      hexiaoInfo: null,
      shopList: [],
      selectedShopName: "",
      shopDialogVisible: false
    };
  },
  computed: {
    finalImportTable() {
      return this.importTableList.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this.currentPage)
    }
  },
  watch: {},
  created() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode
  },
  mounted() {
    // this.countDown();
  },
  methods: {
    // 核销 saveServiceProjectMemberRecord
    selectServe(cow, index){
      this.verificationList = cow;
      this.writeActiveIndex = index;
    },
    async serviceWriteOffFunc(){
      if(!this.verificationList.id || this.writeActiveIndex == -1){
        this.$message({
          message: "请选择核销项目",
          type: "error"
        });
        return;
      }
      const { result, code } = await this.$store.dispatch("verifyServiceProjectApplyByIdMakeAnAppointmentForService", {
        id: this.verificationList.id,
      });
      
      if(result == 'success' && code === "0") {
        this.$message({
          message: "核销成功",
          type: "success"
        });
        this.searchServe(); 
      }

      if(result == 'error'  && code === "0"){
        this.$alert(`<strong><p>该客户预约时间为<span>${this.verificationList.subscribeDate}</span>，当前时间尚未到达。</p></strong>`, '核销失败', {
          dangerouslyUseHTMLString: true
        });
      }


    },


    // 查询待核销列表
    async searchServe(){
      const { result } = await this.$store.dispatch("queryVerifyServiceProjectApplyList", {
        verifyValue: this.serviceMobilePhoneNumber,// 手机号
      });
      
      if(result) {
        this.writeOffList = result;
        this.writeActiveIndex = -1;
      }
    },
    getDayOfWeek(dateString) {
        const date = new Date(dateString); // 将字符串转化为 Date 对象
        const daysOfWeek = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
        // 获取日期对应的星期几（0-6）
        const dayIndex = date.getDay();
        // 返回星期几的名称
        return daysOfWeek[dayIndex];
    },
    filterGt0OrCardFixed2(prop) {
      // this.checkedCardInfo[prop] = this.checkedCardInfo[prop].replace(/^(0+)/, ""); //过滤0开头
      this.checkedCardInfo[prop] = this.checkedCardInfo[prop].replace(
        /[^\d.]/g,
        ""
      ); //仅保留数字和"."
      this.checkedCardInfo[prop] = this.checkedCardInfo[prop].replace(
        /\.{2,}/g,
        "."
      ); //两个连续的"."仅保留第一个"."
      this.checkedCardInfo[prop] = this.checkedCardInfo[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.checkedCardInfo[prop] = this.checkedCardInfo[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.checkedCardInfo[prop].indexOf(".") < 0 &&
        this.checkedCardInfo[prop] != ""
      ) {
        //首位是0的话去掉
        this.checkedCardInfo[prop] = parseFloat(this.checkedCardInfo[prop]);
      }
    },
    cardChange(val) {
      this.checkedCardInfo = this.cardList.find(v => v.cardRelId === val);
    },
    getCurrentRow(row) {
      this.templateSelection = row;
    },
    filterListGt0OrFixed0(i, prop) {
      this.list[i][prop] = this.list[i][prop].replace(/^(0+)/, ""); //过滤0开头
      this.list[i][prop] = this.list[i][prop].replace(/^(0+)|[^\d]+/g, "");
      this.list[i][prop] = this.list[i][prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    filterGt0OrFixed0(prop) {
      this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
      this[prop] = this[prop].replace(/^(0+)|[^\d]+/g, "");
      this[prop] = this[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    checkboxT(row, index) {
      if (row.prizeLevelRemainNum === 0) {
        return false;
      } else {
        if (this.checkedRow.length === 0) {
          return true;
        } else {
          if (this.checkedRow[0].prizeName !== "未中奖") {
            if (index === 0) {
              return false;
            } else {
              return true;
            }
          } else {
            if (index === 0) {
              return true;
            } else {
              return false;
            }
          }
        }
      }
    },
    getChecked(selection) {
      this.checkedRow = selection;
    },
    filterGt0OrFixed2(prop) {
      // this.searchCondition[prop] = this.searchCondition[prop].replace(/^(0+)/, ""); //过滤0开头
      this.searchCondition[prop] = this.searchCondition[prop].replace(
        /[^\d.]/g,
        ""
      ); //仅保留数字和"."
      this.searchCondition[prop] = this.searchCondition[prop].replace(
        /\.{2,}/g,
        "."
      ); //两个连续的"."仅保留第一个"."
      this.searchCondition[prop] = this.searchCondition[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.searchCondition[prop] = this.searchCondition[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.searchCondition[prop].indexOf(".") < 0 &&
        this.searchCondition[prop] != ""
      ) {
        //首位是0的话去掉
        this.searchCondition[prop] = parseFloat(this.searchCondition[prop]);
      }
    },
    hxChange() {
      console.log(44444)   
      this.list = [];
      this.serviceMobilePhoneNumber = "";
      this.writeOffList=[];
    },
    async hxOffline(row) {
      this.dialogVisibleHx = true;
      this.searchCondition.verifyCode = row.verifyCode;
      const { result } = await this.$store.dispatch(
        "writeOffByVerifyCode",
        row
      );
      this.hxList = result;
      this.hxList.unshift({
        prizeLevel: "未中奖",
        prizeName: "未中奖",
        prizeNum: "未中奖"
      });
    },
    async openCoupon(v) {
      this.title = `券名:${v.name}`;
      this.couponCode = v.couponCode;
      this.dialogVisible = true;
      let params = {
        couponCode: v.couponCode,
        centerId: v.memberId
      };
      const { code } = await this.$store.dispatch("writeCouponRule", params);
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });
      }
    },
    qiehuan(val) {
      if (val === "offline" || val === "subscribe") {
        this.state = "hxCode";
      }
      this.total = 0;
      this.currentPage = 1;
      this.pageSize = 10;
      this.list = [];
      this.templateSelection = {};
      // this.queryList();
    },
    findCoupon() {
      this.queryList();
    },
    hxcode() {
      if (this.searchCondition.keyword !== "") {
        if (this.searchCondition.verifyType === "card") {
          if (
            this.searchCondition.verifyMoney === "" ||
            this.searchCondition.verifyMoney <= 0
          ) {
            this.$message({
              message: "请输入核销金额",
              type: "warning"
            });
          } else {
            let params = {
              verifyMoney: this.searchCondition.verifyMoney,
              verifyCodes: [this.searchCondition.keyword]
            };
           
            this.$store.dispatch("chargeOffByVerifyCode", params).then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "核销成功",
                  type: "success"
                });
                this.searchCondition.keyword = "";
                this.searchCondition.verifyMoney = "";
              }
            });
          }
        } else {
          let params = {
            verifyCodes: [this.searchCondition.keyword]
          };
          if (this.searchCondition.verifyType === "subscribe") {
            this.$store.dispatch("guiderFindByVerifyCode", {
              verifyCode: this.searchCondition.keyword,
              storeCode: this.storeCode
            }).then(res => {
              if (res.code === "0") {
                this.hexiaoInfo = res.result;
                // 处理门店列表
                if (this.hexiaoInfo.actShopType === "all") {
                  // 全部门店，需要查询所有启用的门店列表
                  this.$store.dispatch("queryStoreAllEnabledStatusShopList").then(shopRes => {
                    if (shopRes.code === "0") {
                      this.shopList = shopRes.result.map(item => ({ name: item.shopName }));
                      this.selectedShopName = this.shopList[0] && this.shopList[0].name ? this.shopList[0].name : "";
                      this.shopDialogVisible = true;
                    }
                  });
                } else if (this.hexiaoInfo.actShopName) {
                  // 指定门店，解析门店名称
                  this.shopList = this.hexiaoInfo.actShopName.split(',').map(name => ({
                    name: name.replace(/^(直营店-|加盟店-)/, '')
                  }));
                  this.selectedShopName = this.shopList[0] && this.shopList[0].name ? this.shopList[0].name : "";
                  this.shopDialogVisible = true;
                }
              }
            });
          } else {
            this.$store.dispatch("chargeOffByVerifyCode", params).then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "核销成功",
                  type: "success"
                });
                this.searchCondition.keyword = "";
              }
            });
          }
        }
      }
    },
    // 预约活动核销确认
    confirmSubscribeWriteOff() {
      if (!this.selectedShopName) {
        this.$message({
          message: "请选择核销门店",
          type: "warning"
        });
        return;
      }
      let params = {
        verifyCodes: [this.searchCondition.keyword],
        selectedShopName: this.selectedShopName
      };
      this.$store.dispatch("chargeOffByVerifyCode", params).then(res => {
        if (res.code === "0") {
          this.$message({
            message: "核销成功",
            type: "success"
          });
          this.shopDialogVisible = false;
          this.searchCondition.keyword = "";
          this.hexiaoInfo = null;
          this.shopList = [];
          this.selectedShopName = "";
        }
      });
    },
    checkedCoupons(val) {
      this.couponsCodes = val.map(v => v.couponCode);
      this.couponIdList = val.map(v => v.couponId);
    },
    checkedOrder(val) {
      this.orderCodes = val;
    },
    checkedSignin(val) {
      this.signinCodes = val;
    },
    checkedPrize(val) {
      this.prizeCodes = val;
    },
    checkedOffline(val) {
      this.obtainPrize =
        val.prizeLevel === "未中奖"
          ? "未中奖"
          : `${val.prizeLevel}:${val.prizeName}`;
    },
    timeFormat(param) {
      return param < 10 ? "0" + param : param;
    },
    countDown() {
      setInterval(() => {
        this.list.forEach(v => {
          let aaa = new Date(v.endDate).getTime();

          let bbb = new Date().getTime();
          let rightTime = aaa - bbb;

          if (rightTime > 0) {
            var dd = Math.floor(rightTime / 1000 / 60 / 60 / 24);
            var hh = Math.floor((rightTime / 1000 / 60 / 60) % 24);
            var mm = Math.floor((rightTime / 1000 / 60) % 60);
            var ss = Math.floor((rightTime / 1000) % 60);
          }
          v.djs = dd + "天" + hh + "小时" + mm + "分" + ss + "秒";
        });
      }, 1000);
    },
    freeze() {
      if (this.couponIdList.length > 0) {
        let params = {
          couponIdList: this.couponIdList
        };
        this.$store.dispatch("freezeCoupon", params).then(res => {
          if (res.code === "0") {
            this.queryList();
            this.couponIdList = [];
            this.$message({
              message: "操作成功",
              type: "success"
            });
          }
        });
      } else {
        this.$message({
          message: "请选择需要冻结优惠券!",
          type: "warning"
        });
      }
    },
    confirm() {
      let params = {};
      if (this.searchCondition.verifyType === "coupon") {
        if (this.couponsCodes.length > 0) {
          params = {
            verifyCodes: this.couponsCodes,
            verifyRemark: this.verifyRemark,
          };
          this.$store.dispatch("chargeOffByVerifyCode", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "核销成功",
                type: "success"
              });
              this.couponsCodes = [];
              this.queryList();
            }
          });
        } else {
          this.$message({
            message: "请选择核销!",
            type: "warning"
          });
        }
      } else if (this.searchCondition.verifyType === "order") {
        if (this.orderCodes.length > 0) {
          params = {
            verifyCodes: this.orderCodes
          };
          this.$store.dispatch("chargeOffByVerifyCode", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "核销成功",
                type: "success"
              });
              this.orderCodes = [];
              this.queryList();
            }
          });
        } else {
          this.$message({
            message: "请选择核销!",
            type: "warning"
          });
        }
      } else if (this.searchCondition.verifyType === "game") {
        if (this.prizeCodes.length > 0) {
          params = {
            verifyCodes: this.prizeCodes
          };
          this.$store.dispatch("chargeOffByVerifyCode", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "核销成功",
                type: "success"
              });
              this.prizeCodes = [];
              this.queryList();
            }
          });
        } else {
          this.$message({
            message: "请选择核销!",
            type: "warning"
          });
        }
      } else if (this.searchCondition.verifyType === "subscribe") {
        if (this.signinCodes.length > 0) {
          params = {
            verifyCodes: this.signinCodes
          };
          this.$store.dispatch("chargeOffByVerifyCode", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "核销成功",
                type: "success"
              });
              this.signinCodes = [];
              this.queryList();
            }
          });
        } else {
          this.$message({
            message: "请选择核销!",
            type: "warning"
          });
        }
      } else if (this.searchCondition.verifyType === "offline") {
        if (
          this.remainExchangeNum > 0 &&
          this.remainExchangeNum <= this.drawNum
        ) {
          if (this.checkedRow.length) {
            if (this.checkedRow.length <= this.remainExchangeNum * 1) {
              let flag = true;
              this.checkedRow.forEach(v => {
                if (
                  v.memberPrizeNum === "" ||
                  v.prizeLevelRemainNum < v.memberPrizeNum
                ) {
                  flag = false;
                }
              });
              if (flag) {
                if (this.checkedRow[0].prizeName === "未中奖") {
                  let params = {
                    prizeRelModelList: [],
                    verifyCode: this.verifyCode,
                    drawNum: this.remainExchangeNum
                  };
                  this.$store.dispatch("writeOff", params).then(res => {
                    if (res.code === "0") {
                      this.$message({
                        message: "核销成功",
                        type: "success"
                      });
                      if (this.state === "hxCode") {
                        this.searchCondition.verifyCode = "";
                        this.obtainPrize = "";
                        this.checkedRow = [];
                        this.verifyCode = "";
                        this.remainExchangeNum = 0;
                        this.list = [];
                      } else {
                        this.dialogVisibleHx = false;
                        this.hxList = [];
                        this.queryList();
                      }
                    }
                  });
                } else {
                  let params = {
                    prizeRelModelList: this.checkedRow,
                    verifyCode: this.verifyCode,
                    drawNum: this.remainExchangeNum
                  };
                  this.$store.dispatch("writeOff", params).then(res => {
                    if (res.code === "0") {
                      this.$message({
                        message: "核销成功",
                        type: "success"
                      });
                      if (this.state === "hxCode") {
                        this.searchCondition.verifyCode = "";
                        this.obtainPrize = "";
                        this.checkedRow = [];
                        this.verifyCode = "";
                        this.remainExchangeNum = 0;
                        this.list = [];
                      } else {
                        this.dialogVisibleHx = false;
                        this.hxList = [];
                        this.queryList();
                      }
                    }
                  });
                }
              } else {
                this.$message({
                  message: "请填写获奖数,且获奖数不能超过剩余奖品数!",
                  type: "warning"
                });
              }
            } else {
              this.$message({
                message: "核销次数不得超过已选择核销奖项数!",
                type: "warning"
              });
            }
          } else {
            this.$message({
              message: "请选择核销!",
              type: "warning"
            });
          }
        } else {
          this.$message({
            message: "核销次数应大于0,且不得超过剩余可核销次数!",
            type: "warning"
          });
        }
      } else if (this.searchCondition.verifyType === "vouchers") {
        if (this.templateSelection.goodsInfo) {
          let params = {
            couponCode: this.copyCouponCodes,
            props: this.templateSelection.wxshopSpuId
              ? `wxshopSpuId:${this.templateSelection.wxshopSpuId}`
              : `goodsSn:${this.templateSelection.goodsSn}`,
            // props: "test",
            name: this.templateSelection.goodsInfo,
            couponId: this.templateSelection.couponId
          };
          this.$store.dispatch("chargeOffVerifyVoucher", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "核销成功",
                type: "success"
              });
              this.couponCodes = "";
              this.copyCouponCodes = "";
              this.list = [];
              this.radio = "";
              this.templateSelection = {};
            }
          });
        } else {
          this.$message({
            message: "请选择核销!",
            type: "warning"
          });
        }
      }
    },
    search() {
      this.queryList();
    },
    async searchVouchers() {
      if (this.couponCodes === "") {
        this.$message({
          message: "请输入兑换码!",
          type: "warning"
        });
      } else {
        const { result } = await this.$store.dispatch("findCouponRuleGoods", {
          couponCode: this.couponCodes
        });
        this.list = result.records;
        this.total = result.total;
      }
    },
    async queryList() {
      this.templateSelection = {};
      this.radio = "";
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (this.searchCondition.verifyType === "offline") {
        if (this.state === "hxCode") {
          this.verifyCode = searchCondition.verifyCode;
          const { result } = await this.$store.dispatch(
            "writeOffByVerifyCode",
            searchCondition
          );
          result.prizeModelList.forEach(v => {
            v.prizeId = v.id;
            v.memberPrizeNum = "";
          });
          this.list = result.prizeModelList;
          this.drawNum = result.remainExchangeNum;
          this.remainExchangeNum = JSON.parse(
            JSON.stringify(result.remainExchangeNum)
          );
          this.list.unshift({
            prizeLevel: "未中奖",
            prizeName: "未中奖",
            prizeNum: "未中奖"
          });
        } else {
          const { result } = await this.$store.dispatch(
            "queryListByMemberMobile",
            searchCondition
          );
          this.list = result;
        }
      } else if (this.searchCondition.verifyType === "vouchers") {
        if (this.couponCodes === "") {
          this.$message({
            message: "请输入兑换码!",
            type: "warning"
          });
        } else {
          this.copyCouponCodes = JSON.parse(JSON.stringify(this.couponCodes));
          let params = {
            pageNo: this.currentPage,
            pageSize: this.pageSize,
            couponCode: this.couponCodes
          };
          const { result } = await this.$store.dispatch(
            "findCouponRuleGoods",
            params
          );
          if (result) {
            this.list = result.records;
            this.total = result.total;
          } else {
            this.$message({
              message: "该核销码无效!",
              type: "warning"
            });
          }
        }
      } else if (this.searchCondition.verifyType === "card") {
        this.$store
          .dispatch("queryListByCardMemberMobile", searchCondition)
          .then(res => {
            if (res.code === "0") {
              res.result.forEach(v => {
                v.memberMobile = this.searchCondition.memberMobile;
                v.verifyMoney = "";
                v.smsCode = "";
              });
              this.cardList = res.result || [];
              this.checkedCardInfo =
                this.cardList.length > 0 ? this.cardList[0] : {};
            }
          });
      } else {
        let params = {
          pageNo: this.currentPage,
          pageSize: this.pageSize
        };

        Object.assign(params, searchCondition);
        const { result } = await this.$store.dispatch(
          "queryByVerifyCode",
          params
        );
        const { records, total } = result.list;
        if (searchCondition.verifyType === "coupon") {
          records.forEach(v => {
            // v.startDate=v.ruleStartDate+" "+v.ruleStartTime.substring(0, v.ruleStartTime.lastIndexOf(',')),
            // v.endDate=v.ruleEndDate+" "+v.ruleEndTime.substring(0, v.ruleEndTime.lastIndexOf(','))
            this.$set(v, "djs", InitTime(v.endDate));
          });
          this.list = records;
          console.log("this.list: ", this.list);

          this.countDown();
        } else if (searchCondition.verifyType === "order") {
          this.orderList = records;
        } else if (searchCondition.verifyType === "game") {
          this.list = records;
        } else if (searchCondition.verifyType === "subscribe") {
          this.list = records;
        }

        this.total = total;
      }
    },
    async getcode() {
      if (this.checkedCardInfo.memberMobile) {
        await this.$store.dispatch("sendCardCheckCode", {
          memberMobile: this.checkedCardInfo.memberMobile
        });
        this.$message({
          message: "操作成功！",
          type: "success"
        });
      }
    },
    confirmCard() {
      if (this.checkedCardInfo.cardRelId) {
        if (!this.checkedCardInfo.verifyMoney) {
          this.$message({
            message: "请输入核销金额！",
            type: "warning"
          });
        } else if (!this.checkedCardInfo.smsCode) {
          this.$message({
            message: "请输入验证码！",
            type: "warning"
          });
        } else {
          this.checkedCardInfo.verifyMoney = new Number(
            this.checkedCardInfo.verifyMoney
          );
          this.$store
            .dispatch("confirmVerifying", {
              verifyMoney: this.checkedCardInfo.verifyMoney,
              smsCode: this.checkedCardInfo.smsCode,
              cardRelId: this.checkedCardInfo.cardRelId,
              memberMobile: this.checkedCardInfo.memberMobile
            })
            .then(() => {
              this.$message({
                message: "核销成功！",
                type: "success"
              });
              this.checkedCardInfo.cardBalance =
                this.checkedCardInfo.cardBalance -
                this.checkedCardInfo.verifyMoney;
            });
        }
      } else {
        this.$message({
          message: "请选择储值卡！",
          type: "warning"
        });
      }
    },
    paging(page) {
      this.currentPage = page;
      if (this.state !== "batchHx") {
        this.queryList();
      }
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      if (this.state !== "batchHx") {
        this.queryList();
      }
    },
    /**
     * @desc 导出模板excel
    */
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["订单号"];
        const data = [[]];
        exportJsonToExcel(tHeader, data, "批量核销导入模板"+ new Date().toLocaleString());
      });
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        console.log('---result---', result);
        const formatResult = [];
        let isValid = true;
        let isRequired = true;
        result.forEach(v => {
          if (!v[0]) {
            isRequired = false;
          } else {
            if (!that.isString(v[0])) {
              isValid = false;
            }
          }
          formatResult.push({
            receiptSn: v[0],
          });
        });
        console.log('formatResult', formatResult);
        if (isValid && isRequired) {
          // that.importTableList = formatResult;
          let receiptSnList = formatResult.map(item => item.receiptSn)
          that.$store.dispatch('findBillNobyReceiptSnList', {
            storeCode: that.storeCode,
            // storeCode: '53010017032439',
            receiptSnList
          }).then(res => {
            if (res.code === '0') {
              that.importTableList = res.result.storeOrderBasicInfoBillNoListVoList;
              that.billNoList = res.result.billNoList;
              that.hxTotal = res.result.storeOrderBasicInfoBillNoListVoList.length;
            }
          })
          // that.memberCount = formatResult.length;
        } else {
          if (!isRequired) {
            that.$message({
              message: "导入失败，请导入完整订单号！",
              type: "warning"
            });
          } else if (!isValid) {
            that.$message({
              message: "导入失败，订单号请使用文本格式导入！",
              type: "warning"
            });
          }
        }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    isString(value) {
      return typeof value === "string";
    },
    /**
     * @desc 批量核销
    */
   handleHx() {
    // if(!this.hxRemark) {
    //   this.$message({
    //     message: "请输入核销备注！",
    //     type: "warning"
    //   });
    //   return;
    // }
    if( this.billNoList.length){
      let params = {
        verifyCodes: this.billNoList,
        verifyRemark: this.hxRemark,
      };
      this.$store.dispatch("chargeOffByVerifyCode", params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "核销成功",
              type: "success"
            });
            this.importTableList = [];
            this.billNoList = [];
            this.hxTotal = 0;
            this.hxRemark = "";
            this.queryList();
          }
        });
      } else {
        this.$message({
          message: "请导入订单！",
          type: "warning"
        });
      }
    }
  }
};
</script>
<style lang="scss">
.tableoffline {
  .el-table__header-wrapper .el-checkbox {
    //找到表头那一行，然后把里面的复选框隐藏掉
    display: none;
  }
}
</style>
<style lang="scss" scoped>
.services {
  .table {
    margin-top: 13px;
    display: flex;
    flex-wrap: wrap;
    .list {
      width: 340px;
      background: #FBFDFF;
      border-radius: 8px;
      border: 1px solid #DFDFDF;
      padding: 10px;
      box-sizing: border-box;
      margin-right: 22px;
      margin-bottom: 22px;
      cursor: pointer;
      .list_title {
        width: 100%;
        height: 32px;
        border-bottom: 1px solid #EAEAEA;
        align-items: center;
        h3 {
          height: 22px;
          font-weight: 500;
          font-size: 15px;
          color: rgba(0,0,0,0.8);
          line-height: 21px;
        }
      }
      .name_mobile {
        align-items: center;
        margin-top: 4px;
        p {
          height: 22px;
          font-weight: 500;
          line-height: 21px;
        }
        .username {
          font-size: 15px;
          color: rgba(0,0,0,0.8);
          margin-right: 5px;
        }
        .cellPhone {
          font-size: 13px;
          color: #000000;
        }
      }
      .number {
        height: 22px;
        font-weight: 400;
        font-size: 13px;
        color: #949494;
        line-height: 21px;
      }
      .time {
        height: 22px;
        font-weight: 500;
        font-size: 15px;
        color: #0862EC;
        line-height: 21px;
      }
      img {
        width: 15px;
        height: 16px;
        margin-right: 5px;
      }
      ul {
        width: 100%;
        height: 51px;
        background: #F3F3F3;
        border-radius: 4px;
        display: flex;
        align-items: center;
        li {
          width: 25%;
          .th {
            height: 17px;
            font-weight: 600;
            font-size: 13px;
            color: rgba(0,0,0,0.9);
            line-height: 17px;
            text-align: center;
            margin-bottom: 6px;
          }
          .tr {
            height: 16px;
            font-weight: 500;
            font-size: 12px;
            color: #949494;
            line-height: 14px;
            text-align: center;
          }
        }
      }
    }
    .list.active {
      border: 1px solid #0862EC;
      ul {
        background: #E0EDFF;
      }
    }
  }
}




.hmicon {
  color: #e50065ff;
  font-size: 14px;
  line-height: 14px;
  margin-top: 5px;
  icon-wenhao {
    font-size: 14px;
    line-height: 14px;
    color: #e50065ff;
  }
}
.scenario {
  font-size: 14px;
  color: rgba(34, 34, 34, 1);
}
.header-tutorial {
  font-weight: 600;
  font-size: 17px;
  line-height: 17px;
}
.tit-tutorial {
  font-weight: 500;
  font-size: 15px;
  line-height: 15px;
}
.phone-hxbd {
  border: 1px solid #ddd;
  // -webkit-overflow-scrolling: touch;
  // overflow-y: scroll;
  // height: 540px;
}
// .phone-hxbd::-webkit-scrollbar {
//   width: 10px;
//   height: 1px;
// }
// .phone-hxbd::-webkit-scrollbar-thumb {
//   border-radius: 10px;
//   box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
//   background: #535353;
// }
// .phone-hxbd::-webkit-scrollbar-track {
//   box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
//   border-radius: 10px;
//   background: #ededed;
// }
.list-item {
  width: 440px;
  margin-left: 30px;
  margin-bottom: 20px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  .list-box {
    box-sizing: border-box;
    box-shadow: 0px 0px 43px 0px rgba(197, 197, 197, 0.43);
    border-radius: 6px;
    &.act0 {
      background-image: url(https://imgcdn.hemiao100.com/ThemePictures/0.png);
      background-size: 60px;
      background-repeat: no-repeat;
      background-position: 100% 0;
    }
    &.act1 {
      background-image: url(https://imgcdn.hemiao100.com/ThemePictures/1.png);
      background-size: 60px;
      background-repeat: no-repeat;
      background-position: 100% 0;
    }
    &.act2 {
      background-image: url(https://imgcdn.hemiao100.com/ThemePictures/2.png);
      background-size: 60px;
      background-repeat: no-repeat;
      background-position: 100% 0;
    }
    &.act3 {
      background-image: url(https://imgcdn.hemiao100.com/ThemePictures/3.png);
      background-size: 60px;
      background-repeat: no-repeat;
      background-position: 100% 0;
    }
    &.act4 {
      background-image: url(https://imgcdn.hemiao100.com/ThemePictures/4.png);
      background-size: 60px;
      background-repeat: no-repeat;
      background-position: 100% 0;
    }
    &.act5 {
      background-image: url(https://imgcdn.hemiao100.com/ThemePictures/5.png);
      background-size: 60px;
      background-repeat: no-repeat;
      background-position: 100% 0;
    }
  }
  .list-left {
    width: 125px;
    height: 100%;
    background-color: #fcca8e;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .zhekou {
      font-size: 22px;
      text-align: center;
    }

    .tiaojian {
      font-size: 12px;
      margin-top: 10px;
      text-align: center;
    }
  }
  .list-right {
    .right-top {
      padding: 16px;
      .right-title {
        font-size: 16px;
        font-weight: 600;
      }
      .right-time {
        color: #909090;
        margin-top: 6px;
      }
      .remaining-time {
        color: red;
      }
    }
  }
  .circle1 {
    position: absolute;
    z-index: 5;
    top: -5px;
    left: 25px;
    transform-origin: center left;
    transform: rotate(90deg);
    width: 110px;
    height: 9px;
    background-image: radial-gradient(
      circle,
      #fcca8e,
      #fcca8e 4px,
      transparent 0px,
      transparent 2px,
      transparent 22px,
      transparent
    );
    background-size: 10px 10px;
    background-repeat: repeat-x;
  }
}
.list-order {
  width: 410px;
  padding: 15px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 43px 0px rgba(197, 197, 197, 0.43);
  border-radius: 6px;
  .order-img {
    width: 80px;
    height: 80px;
    border-radius: 6px;
  }
}
.list-signin {
  width: 450px;
  padding: 15px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 43px 0px rgba(197, 197, 197, 0.43);
  border-radius: 6px;
  .signin-img {
    width: 100px;
    height: 80px;
    border-radius: 6px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .info-content {
    width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.list-prize {
  width: 400px;
  padding: 15px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 43px 0px rgba(197, 197, 197, 0.43);
  border-radius: 6px;
  .prize-img {
    width: 80px;
    height: 80px;
    border-radius: 6px;
  }
}
.nnn {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.font-style {
  color: #222222;
  font-weight: 600;
  font-size: 16px;
}
.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.hx-remark-wrap {
  // align-items: flex-start;
  .label {
    white-space: nowrap;
  }
}
</style>
